// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__NyAq8","fade-in":"Menu_fade-in__xdbB5"};